import { Box, Header, Text, addWithConfig } from '@rbilabs/universal-components';

import ActionButtonLink from 'components/action-button';

export const EmptyStateWrapper = Box.withConfig({
  marginTop: '$8',
  alignItems: 'center',
  justifyContent: 'center',
  color: Styles.color.black,
  textAlign: 'center',
  paddingY: '$0',
  paddingX: '$8',
  padding: {
    md: '$0',
  },
});

export const StyledActionButtonLink = addWithConfig(ActionButtonLink).withConfig({
  marginTop: '$6',
  _text: { fontFamily: 'heading' },
});

export const HeaderText = Header.withConfig({
  variant: 'headerFour',
  margin: 0,
  fontSize: '2xl',
  lineHeight: 'md',
  marginTop: '$5',
  fontWeight: 'normal',
});

export const SubText = Text.withConfig({
  marginX: '$16',
  marginTop: '$1',
  fontSize: 'md',
  textAlign: 'center',
});

export const ImageWrapper = Box.withConfig({
  width: '$40',
  height: '$40',
});
